import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import Images from "../../Assets/Images";
import EmailService from "../../Services/EmailService";

/**
 * A reusable component for sending charts via email
 * @param {Object} props - Component props
 * @param {Function} props.onSendEmail - Function to call when sending email
 * @param {string} props.widgetId - ID of the widget/chart
 * @param {string} props.widgetName - Name of the widget/chart
 */
const EmailChartPopup = ({ onSendEmail, widgetId, widgetName }) => {
  const [emailId, setEmailId] = useState("");
  const [message, setMessage] = useState("");

  const handleSendEmail = () => {
    if (onSendEmail) {
      onSendEmail(emailId, message);
    }
  };

  return (
    <Dropdown menuAlign="right" title="Mail" id="dropdown-menu-align-right">
      <Dropdown.Toggle>
        <a>
          <img src={Images.EMAIL} alt="Share" width="14" />
        </a>
      </Dropdown.Toggle>
      <Dropdown.Menu className="filterList emailBox">
        <div className="filterBox">
          <div className="dateRange">
            <div className="dateCont">
              <h6>Email</h6>
              <input
                type="email"
                autoComplete="off"
                value={emailId}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>
            <div className="dateCont">
              <h6>Message</h6>
              <textarea
                value={message}
                autoComplete="off"
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <Dropdown.Item as="button" onClick={handleSendEmail}>
                SEND
              </Dropdown.Item>
            </div>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default EmailChartPopup;